import moment from 'moment';
import { inPercent } from 'helpers/Utils.js';

/**
 * Parse timestamp and return formatted date.
 * @param  {Number} timestamp Timestamp
 * @return {String}           `Month day` formatted string.
 */
export const dateTickFormatter = timestamp => moment(timestamp).format('MMM DD');

export const pctTickFormatter = tick => inPercent(tick);
